import React from 'react';
import { Box } from '@mui/material';
import MicOffIcon from '@mui/icons-material/MicOff';
import { useTranslation } from 'react-i18next';

import { DS } from '../designTokens';

type Props = {
  name: string;
};

const MutedBadge = ({ name }: Props) => {
  const { t } = useTranslation();
  const label = t('videoVisit.status.remoteMuted', { name });

  return (
    <Box
      role="img"
      aria-label={label}
      title={label}
      sx={{
        flex: 'none',
        display: 'grid',
        placeItems: 'center',
        width: 16,
        height: 16,
        borderRadius: '50%',
        bgcolor: DS.dawn,
        color: DS.softBlack,
      }}
    >
      <MicOffIcon sx={{ fontSize: 11 }} />
    </Box>
  );
};

export default MutedBadge;
